import React from 'react';
import {MainLayout} from 'components/layouts';
import {HighlightBusinessForm} from 'components/highlight-businesses';
import {HighlightBusinesses} from 'base/api';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';

class EditHighlightBusinessPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    const id = this.props.match && this.props.match.params && this.props.match.params.id;
    let homeBanner = null;
    if (this.props.listHighlightBusinesses && id) {
      homeBanner = this.props.listHighlightBusinesses.find(item => item.id === id);
    }
    this.state = {
      homeBanner,
      id
    }
  }

  componentDidMount() {
    const id = this.props.match && this.props.match.params && this.props.match.params.id;
    if (!id) {
      return;
    }
    if (!this.state.homeBanner && (!this.props.listHighlightBusinesses || this.props.listHighlightBusinesses.length === 0)) {
      HighlightBusinesses.actions.get.request({id}).then(response => {
        this.setState({
          homeBanner: response.data
        });
      });
    }
  }

  componentWillReceiveProps(nexProps) {
    if (nexProps.listHighlightBusinesses && nexProps.listHighlightBusinesses.length > 0 && nexProps.listHighlightBusinesses !== this.props.listHighlightBusinesses) {
      const id = this.props.match && this.props.match.params && this.props.match.params.id;
      let homeBanner = null;
      if (this.props.listHighlightBusinesses && id) {
        homeBanner = this.props.listHighlightBusinesses.find(item => item.id === id);
        this.setState({homeBanner});
      }
    }
  }

  cb(response) {
    // Back to home banners list
    toastr.success('Thành công!', 'Danh mục đã được cập nhật thành công.');

    this.props.history.push('/highlight-businesses');
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className="register-logo">
            <b>Cập nhật banner</b>
          </div>
          <HighlightBusinessForm fnSubmit={HighlightBusinesses.actions.update} cb={this.cb.bind(this)} data={this.state.homeBanner}/>
        </div>
      </MainLayout>
    );
  }
}

EditHighlightBusinessPage.contextTypes = {
  router: React.PropTypes.object
};

const bindStateToProps = state => {
  return {
    listHighlightBusinesses: state.listHighlightBusinesses
  }
};

export default connect(bindStateToProps)(EditHighlightBusinessPage);



// WEBPACK FOOTER //
// ./pages/highlight-businesses/EditHighlightBusinessPage.jsx